module.exports = __webpack_public_path__ + "static/media/374.739085f0.svg";